import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon52: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#FFD147"
        d="M12.5 0a.5.5 0 0 1 .5.5V2h2.5a.5.5 0 0 1 .492.41L16 2.5v4.487A2.013 2.013 0 0 1 13.987 9H13v1c0 2.615-1.996 4.654-4.499 4.886v3.61a19.72 19.72 0 0 1 4.116.518.5.5 0 1 1-.234.972c-1.343-.324-2.854-.497-4.424-.497l.133.003a.562.562 0 0 1-.187-.001 18.647 18.647 0 0 0-4.289.495.5.5 0 0 1-.232-.972 19.727 19.727 0 0 1 4.575-.525l-.459.006.001-3.613a5.689 5.689 0 0 1-.538-.081C4.608 14.327 3 12.388 3 10V9h-.987A2.011 2.011 0 0 1 .006 7.137L0 6.987V2.5A.5.5 0 0 1 .5 2H3V.5a.5.5 0 0 1 .5-.5h9ZM12 1H4v9c0 1.909 1.27 3.44 3.161 3.821C9.717 14.335 12 12.498 12 10V1Zm1 7h.987C14.547 8 15 7.547 15 6.987V3h-2v5ZM3 8V3H1v3.987C1 7.547 1.453 8 2.013 8H3Z"
      />
    </Svg>
  )
}
